module.exports = __webpack_public_path__ + "r-v3/img/sticker_16.61aeca55.svg";